import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useParams, useNavigate, Link } from "react-router-dom";
import AddForumModal from './addForumModal';
import AddPersonModal from './addPersonModal';

// Styled Components
const Divider = styled.div`
  position: relative;
  height: 1px;
`;

const DivTransparent = styled(Divider)`
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 1px;
    background-image: linear-gradient(to right, transparent, rgb(48,49,51), transparent);
  }
`;

const DivArrowDown = styled(DivTransparent)`
  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    top: -6.5px;
    left: calc(75% - 7px);
    width: 14px;
    height: 14px;
    transform: rotate(45deg);
    background-color: white;
    border-bottom: 1px solid rgb(48,49,51);
    border-right: 1px solid rgb(48,49,51);
  }
`;

// Main Component
function GerarProcesso() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [authenticated, setAuthenticated] = useState(false);
  const [responseProcess, setResponseProcess] = useState([]);
  const [responseForum, setResponseForum] = useState([]);
  const [responseCliente, setResponseCliente] = useState([]);
  const [responsePessoa, setResponsePessoa] = useState([]);
  const [user, setUser] = useState(null);

  // Form States
  const [processo, setProcesso] = useState('');
  const [valorEstimado, setValorEstimado] = useState('');
  const [forum, setForum] = useState('');
  const [cliente, setCliente] = useState('');
  const [inicioProcesso, setInicioProcesso] = useState('');
  const [estimada, setEstimada] = useState('');
  const [acao, setAcao] = useState('');
  const [pasta, setPasta] = useState('');
  const [autor, setAutor] = useState('');
  const [reu, setReu] = useState('');
  const [advogado, setAdvogado] = useState('');
  const [advAutor, setAdvAutor] = useState('');
  const [observacao, setObservacao] = useState('');

  // Pessoa Fields
  const [nomePessoa, setNomePessoa] = useState('');
  const [telefonePessoa, setTelefonePessoa] = useState('');
  const [cpfCnpjPessoa, setCpfCnpjPessoa] = useState('');

  // Error State
  const [errors, setErrors] = useState([]);

  // Modal States
  const [showAddForumModal, setShowAddForumModal] = useState(false);
  const [showAddPersonModal, setShowAddPersonModal] = useState(false);
  const [descricaoForum, setDescricaoForum] = useState('');

  useEffect(() => {
      axios.post('https://guias.almeidaenogueira.com.br/api/getgenerate', {
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.auth === true) {
            setAuthenticated(true);
            setResponseProcess(response.data.resp);
            setResponseForum(response.data.resForum);
            setResponseCliente(response.data.resCliente);
            setUser(response.data.user);
            setResponsePessoa(response.data.resPessoa);

            // Carrega os dados do localStorage
            const savedFormData = JSON.parse(localStorage.getItem('formData'));
            if (savedFormData) {
              setProcesso(savedFormData.processo || '');
              setValorEstimado(savedFormData.valorEstimado || '');
              setForum(savedFormData.forum || '');
              setCliente(savedFormData.cliente || '');
              setInicioProcesso(savedFormData.inicioProcesso || '');
              setEstimada(savedFormData.estimada || '');
              setAcao(savedFormData.acao || '');
              setPasta(savedFormData.pasta || '');
              setAutor(savedFormData.autor || '');
              setReu(savedFormData.reu || '');
              setAdvogado(savedFormData.advogado || '');
              setAdvAutor(savedFormData.advAutor || '');
              setObservacao(savedFormData.observacao || '');
              setDescricaoForum(savedFormData.descricaoForum || '');
              setNomePessoa(savedFormData.nomePessoa || '');
              setTelefonePessoa(savedFormData.telefonePessoa || '');
              setCpfCnpjPessoa(savedFormData.cpfCnpjPessoa || '');
            }
          } else {
            navigate('/login');
          }
        })
        .catch(() => {
          navigate('/login');
        });
    
  }, [navigate]);

  // Form Handlers
  const handleInputChange = (event) => {
    const { value } = event.target;

    const newValue = value
      .replace(/\D/g, '') // Remove tudo que não for número
      .replace(/^0+/, '') // Remove os zeros iniciais
      .padStart(3, '0') // Adiciona zeros à esquerda, caso necessário
      .replace(/(\d{1,})(\d{2})$/, '$1,$2') // Adiciona a vírgula decimal
      .replace(/(?=(\d{3})+(\D))\B/g, '.'); // Adiciona o ponto como separador de milhares

    const formattedValue = `R$ ${newValue}`;
    setValorEstimado(formattedValue);
    saveFormData({ valorEstimado: formattedValue });
  };

  const saveFormData = (updatedData) => {
    const formData = {
      processo,
      valorEstimado,
      forum,
      cliente,
      inicioProcesso,
      estimada,
      acao,
      pasta,
      autor,
      reu,
      advogado,
      advAutor,
      observacao,
      descricaoForum,
      nomePessoa,
      telefonePessoa,
      cpfCnpjPessoa,
      ...updatedData, // Atualiza apenas o campo que mudou
    };
    localStorage.setItem('formData', JSON.stringify(formData));
  };

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
    saveFormData({ [event.target.name]: event.target.value });
  };

  // CPF/CNPJ Formatting
  const handleCpfCnpjChange = (event) => {
    const { value } = event.target;
    const newValue = value.replace(/\D/g, '');

    if (newValue.length <= 11) {
      const formattedValue = newValue.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (match, p1, p2, p3, p4) => {
        if (p4) return `${p1}.${p2}.${p3}-${p4}`;
        return `${p1}.${p2}.${p3}`;
      });
      setCpfCnpjPessoa(formattedValue);
      saveFormData({ cpfCnpjPessoa: formattedValue });
    } else if (newValue.length <= 14) {
      const formattedValue = newValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, (match, p1, p2, p3, p4, p5) => {
        if (p5) return `${p1}.${p2}.${p3}/${p4}-${p5}`;
        return `${p1}.${p2}.${p3}/${p4}`;
      });
      setCpfCnpjPessoa(formattedValue);
      saveFormData({ cpfCnpjPessoa: formattedValue });
    } else {
      setCpfCnpjPessoa(newValue);
      saveFormData({ cpfCnpjPessoa: newValue });
    }
  };

  // Phone Number Formatting
  const handlePhoneChange = (value, setPhone) => {
    const newValue = value.replace(/\D/g, '');
    let formattedValue = '';

    if (newValue.length <= 10) {
      formattedValue = newValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      formattedValue = newValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    setPhone(formattedValue);
    saveFormData({ telefonePessoa: formattedValue });
  };

  const handlePhoneChangeHandler = (event) => {
    handlePhoneChange(event.target.value, setTelefonePessoa);
  };

  // Handling Modals

  const handleCadastrarPessoa = async (event) => {
    event.preventDefault();

    if (!nomePessoa.trim() || !telefonePessoa.trim() || !cpfCnpjPessoa.trim()) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    try {
      const response = await axios.post(`https://guias.almeidaenogueira.com.br/api/new/partner/${id}`, {
        nome: nomePessoa,
        telefone: telefonePessoa,
        cpf_cnpj: cpfCnpjPessoa,
      }, {
        withCredentials: true,
      });

      if (response.data === 400) {
        alert("Essa pessoa/cpf já está cadastrado!");
      } else if (response.data === 404) {
        navigate('/new/partner/erro');
      } else if (response.data.erros.length === 0) {
        navigate(0); // Recarrega a página
      } else {
        const newErrors = response.data.erros.map(error => error.elemento);
        setErrors(newErrors.map(elemento => ({ elemento, mensagem: "Erro no campo" })));
      }
    } catch (error) {
      console.error('Erro ao cadastrar pessoa:', error);
      alert('Algo de errado aconteceu! ' + error);
    }
  };

  // Generate Process Handler
  const handleGenerateProcess = async () => {
    const divErros = document.querySelector('#erros');
    if (divErros) {
      divErros.innerHTML = '';
    }

    try {
      const response = await axios.post('/api/generate/process', {
        processo,
        valorEstimado,
        forum,
        cliente,
        inicioProcesso,
        estimada,
        acao,
        pasta,
        observacao,
        reu,
        autor,
        advogado,
        advAutor,
      }, {
        withCredentials: true,
      });

      if (response.data.erros.length === 0) {
        localStorage.removeItem('formData');
        navigate(`/ci/pagamentos/${response.data.id}`);
      } else {
        response.data.erros.forEach(error => {
          const elemento = document.getElementById(error.elemento);
          if (elemento) {
            elemento.style.backgroundColor = '#FFC0CB';
          }

          const errorDiv = document.createElement('div');
          errorDiv.className = 'row mt-3';
          errorDiv.style.padding = '10px';
          errorDiv.style.borderRadius = '5px';

          const errorCol = document.createElement('div');
          errorCol.style.display = 'inline-block';
          errorCol.style.backgroundColor = '#FFC0CB';
          errorCol.textContent = error.mensagem;

          errorDiv.appendChild(errorCol);
          divErros.appendChild(errorDiv);
        });
      }
    } catch (error) {
      console.error('Erro ao gerar processo:', error);
      alert('Algo de errado aconteceu! ' + error);
    }
  };

  // Cancel Handler
  const handleCancel = () => {
    localStorage.removeItem('formData');
    // Clear form fields
    setProcesso('');
    setValorEstimado('');
    setForum('');
    setCliente('');
    setInicioProcesso('');
    setEstimada('');
    setAcao('');
    setPasta('');
    setAutor('');
    setReu('');
    setAdvogado('');
    setAdvAutor('');
    setObservacao('');
    navigate('/ci/controle');
  };

  // Render Loading Spinner while authenticating
  if (!authenticated) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}>
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect non-admin users
  if (user && user.id !== 1) {
    navigate('/bad/request');
    return null;
  }

  return (
    <>
      <section className="content">
        <div className="container-fluid" style={{ marginTop: 18 }}>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header bg-info">
                  <div className="inner text-center">
                    <img src="/dist/img/martelo.png" alt="Ícone" />
                  </div>
                  <h3 className="text-center">Controle de CI</h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6" style={{ marginBottom: 10 }}>
                      <Link to='/ci/controle'>
                        <div className="text-center">
                          <span style={{ color: "#212529" }}>Consultar Processos</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-6">
                      <Link to='/ci/novo/processo'>
                        <div className="text-center">
                          <span style={{ color: "#17a2b8" }}>Gerar Novo Processo</span>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <DivArrowDown />
                  <section>
                    <h5 style={{ marginTop: 15 }}>Gerar Novo Processo</h5>
                    <div id='erros'>
                      {errors.map((error, index) => (
                        <div key={index} className="row mt-3" style={{ padding: '10px', borderRadius: '5px', backgroundColor: '#FFC0CB' }}>
                          <div style={{ display: 'inline-block' }}>{error.mensagem}</div>
                        </div>
                      ))}
                    </div>
                    <form>
                      {/* Processo e Valor Estimado */}
                      <div className="row" style={{ marginTop: 25 }}>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="processo">Processo</label>
                            <input
                              type="text"
                              className="form-control"
                              id="processo"
                              placeholder="Número do Processo do Documento"
                              name='processo'
                              value={processo}
                              onChange={handleChange(setProcesso)}
                              style={{ backgroundColor: errors.find(e => e.elemento === 'processo') ? '#FFC0CB' : '' }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="valorEstimado">Valor Estimado da Causa</label>
                            <input
                              type="text"
                              value={valorEstimado}
                              className="form-control"
                              id="valorEstimado"
                              name='valorEstimado'
                              onChange={handleInputChange}
                              style={{ backgroundColor: errors.find(e => e.elemento === 'valorEstimado') ? '#FFC0CB' : '' }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Fórum e Cliente */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="forum">Fórum</label>
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn btn-outline-success"
                                  onClick={() => setShowAddForumModal(true)}
                                >
                                  Adicionar
                                </button>
                              </div>
                              <select
                                className="form-control"
                                id="forum"
                                name='forum'
                                value={forum}
                                onChange={handleChange(setForum)}
                                style={{ backgroundColor: errors.find(e => e.elemento === 'forum') ? '#FFC0CB' : '' }}
                              >
                                <option value="">Selecione</option>
                                {responseForum && responseForum.map(res => (
                                  <option key={res.id} value={res.descricao}>{res.descricao}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="cliente">Selecione o cliente</label>
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn btn-outline-success"
                                  onClick={() => setShowAddPersonModal(true)}
                                >
                                  Adicionar
                                </button>
                              </div>
                              <select
                                className="form-control"
                                id="cliente"
                                name='cliente'
                                value={cliente}
                                onChange={handleChange(setCliente)}
                                style={{ backgroundColor: errors.find(e => e.elemento === 'cliente') ? '#FFC0CB' : '' }}
                              >
                                <option value="">Selecione um cliente</option>
                                {responseCliente && responseCliente.map(resp => (
                                  <option key={resp.id} value={resp.nome}>{resp.nome}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Data do Início do Processo */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="inicioProcesso">Data do Início do Processo</label>
                            <input
                              type="date"
                              className="form-control"
                              id="inicioProcesso"
                              name='inicioProcesso'
                              value={inicioProcesso}
                              onChange={handleChange(setInicioProcesso)}
                              style={{ backgroundColor: errors.find(e => e.elemento === 'inicioProcesso') ? '#FFC0CB' : '' }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Ação e Pasta */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="acao">Selecione uma Ação</label>
                            <select
                              className="form-control"
                              id="acao"
                              name='acao'
                              value={acao}
                              onChange={handleChange(setAcao)}
                              style={{ backgroundColor: errors.find(e => e.elemento === 'acao') ? '#FFC0CB' : '' }}
                            >
                              <option value="">Selecione</option>
                              {responseProcess && responseProcess.map(resp => (
                                <option key={resp.id} value={resp.nome}>{resp.nome}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="required" htmlFor="pasta">Informe o Número da Pasta</label>
                            <input
                              type="text"
                              className="form-control"
                              id="pasta"
                              name='pasta'
                              value={pasta}
                              onChange={handleChange(setPasta)}
                              style={{ backgroundColor: errors.find(e => e.elemento === 'pasta') ? '#FFC0CB' : '' }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Campos Adicionais para Admin */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="advogado">Advogado (a) réu</label>
                            <br/>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm mb-2"
                              onClick={() => setShowAddPersonModal(true)}
                            >
                              <i className="fas fa-plus"></i> Adicionar Nova Pessoa
                            </button>
                            <select
                              className="form-control"
                              name="advogado"
                              id="advogado"
                              value={advogado}
                              onChange={handleChange(setAdvogado)}
                            >
                              <option value="">Selecione</option>
                              {responsePessoa && responsePessoa.map((dados) => (
                                <option key={dados.id} value={dados.nome}>{dados.nome}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="reu">Réu</label>
                            <br/>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm mb-2"
                              onClick={() => setShowAddPersonModal(true)}
                            >
                              <i className="fas fa-plus"></i> Adicionar Nova Pessoa
                            </button>
                            <select
                              className="form-control"
                              name="reu"
                              id="reu"
                              value={reu}
                              onChange={handleChange(setReu)}
                            >
                              <option value="">Selecione</option>
                              {responsePessoa && responsePessoa.map((dados) => (
                                <option key={dados.id} value={dados.nome}>{dados.nome}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="advAutor">Advogado (a) autor</label>
                            <br/>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm mb-2"
                              onClick={() => setShowAddPersonModal(true)}
                            >
                              <i className="fas fa-plus"></i> Adicionar Nova Pessoa
                            </button>
                            <select
                              className="form-control"
                              name="advAutor"
                              id="advAutor"
                              value={advAutor}
                              onChange={handleChange(setAdvAutor)}
                            >
                              <option value="">Selecione</option>
                              {responsePessoa && responsePessoa.map((dados) => (
                                <option key={dados.id} value={dados.nome}>{dados.nome}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="autor">Autor</label>
                            <br/>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm mb-2"
                              onClick={() => setShowAddPersonModal(true)}
                            >
                              <i className="fas fa-plus"></i> Adicionar Nova Pessoa
                            </button>
                            <select
                              className="form-control"
                              name="autor"
                              id="autor"
                              value={autor}
                              onChange={handleChange(setAutor)}
                            >
                              <option value="">Selecione</option>
                              {responsePessoa && responsePessoa.map((dados) => (
                                <option key={dados.id} value={dados.nome}>{dados.nome}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Observação */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="observacao">Observação</label>
                            <textarea
                              className="form-control"
                              id="observacao"
                              rows="6"
                              name='observacao'
                              value={observacao}
                              onChange={handleChange(setObservacao)}
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <button type='button' className='btn btn-success' onClick={handleGenerateProcess}>Salvar</button>
                      {' '}
                      <button type='button' className='btn btn-secondary' onClick={handleCancel}>Cancelar</button>
                    </form>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal para adicionar novo fórum */}
      <AddForumModal
        show={showAddForumModal}
        onClose={() => setShowAddForumModal(false)}
        descricaoForum={descricaoForum}
        setDescricaoForum={setDescricaoForum}
      />

      {/* Modal para adicionar nova pessoa */}
      <AddPersonModal
        show={showAddPersonModal}
        onClose={() => setShowAddPersonModal(false)}
        nomePessoa={nomePessoa}
        setNomePessoa={setNomePessoa}
        telefonePessoa={telefonePessoa}
        setTelefonePessoa={setTelefonePessoa}
        cpfCnpjPessoa={cpfCnpjPessoa}
        setCpfCnpjPessoa={setCpfCnpjPessoa}
        cadastrarPessoa={handleCadastrarPessoa}
      />
    </>
  );
}

export default GerarProcesso;
